import { render, staticRenderFns } from "./PaperPostcard.vue?vue&type=template&id=447a4adb&scoped=true&"
import script from "./PaperPostcard.vue?vue&type=script&lang=js&"
export * from "./PaperPostcard.vue?vue&type=script&lang=js&"
import style0 from "./PaperPostcard.vue?vue&type=style&index=0&id=447a4adb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447a4adb",
  null
  
)

component.options.__file = "PaperPostcard.vue"
export default component.exports